<template>
    <div class="full-wdith-adv" ref="advDisplayDom">
        <div class="adv-title-part">
            <span>{{record.advTitle}}</span>
        </div>

        <div class="video-part" v-if="videoVisible" :style="videoStyleObj">

            <img
                class="cover-img"
                :src="record.advImg"
                alt="cover"
            >

            <div class="video-div">
                <AdvIframe
                    :width="advWidth"
                    :height="advHeight"
                    :videoUrl="record.advUrl"
                    v-if="myUtil.isEmpty(record.advVideoPath) && myUtil.isNotEmpty(record.advUrl)"
                />

                <AdvVideo
                    :width="advWidth"
                    :height="advHeight"
                    :videoUrl="record.advVideoPath"
                    v-if="myUtil.isNotEmpty(record.advVideoPath)"
                />
            </div>

        </div>

        <div style="margin-top: 24px">
            <AdvShareBtnGroup
                :fbUrl="record.fbUrl"
                :redUrl="record.redUrl"
                :tiktokUrl="record.titokUrl"
                :ytbUrl="record.ytbUrl"
            />
        </div>

<!--        <div class="adv-des-part">-->
<!--            <span>{{record.advDes}}</span>-->
<!--        </div>-->
    </div>
</template>

<script setup>

import {onMounted, ref} from "vue";
import AdvIframe from "@/components/shopopee/promotion/advIframe.vue";
import AdvVideo from "@/components/shopopee/promotion/advVideo.vue";
import AdvShareBtnGroup from "@/components/shopopee/buttonGroup/advShareBtnGroup.vue";
import myUtil from "@/util/util";

const props = defineProps(["record"])

const advDisplayDom = ref(null)

const domWidth = ref(500)
const advWidth = ref(480)
const advHeight = ref(360)
const videoVisible = ref(false)
const videoStyleObj = ref({})

onMounted(() => {
    setTimeout(() => {
        domWidth.value = advDisplayDom.value.offsetWidth
        advWidth.value = domWidth.value - 20
        advHeight.value = Math.floor(advWidth.value / 16 * 9)

        if (advHeight.value > window.innerHeight - 80){
            advHeight.value = window.innerHeight - 80
            advWidth.value = Math.floor(advHeight.value / 9 * 16)
        }

        videoStyleObj.value = {
            width: `${advWidth.value}px`,
            height: `${advHeight.value}px`
        }

        videoVisible.value = true
    }, 500)
})

</script>

<style scoped>

.full-wdith-adv {
    width: 100%;
    box-sizing: border-box;
}

.adv-title-part {
    text-align: center;
    color: #606266;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
}

.adv-des-part {
    text-align: left;
    color: #606266;
    font-size: 12px;
    margin-top: 20px;
}

.video-part {
    position: relative;
    margin: auto;
}

.cover-img {
    z-index: 0;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.video-div {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

</style>